import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["title"]

import { computed } from 'vue';
import { CameraOff } from 'lucide-vue-next';
import { i18n } from '@/plugins/internationalization/i18n';


export default /*@__PURE__*/_defineComponent({
  __name: 'DegradedCameraMarker',
  props: {
    contributing: {},
    expected: {}
  },
  setup(__props: any) {

const props = __props;

// Strictly fewer, never a subtraction. A camera unmounted within the staleness window reported
// inside it while no longer being mounted, so `contributing` can legitimately exceed `expected` -
// treating that as a shortfall would render "based on 3 of 2 cameras", or worse a negative count.
const isDegraded = computed(() => props.contributing !== null && props.expected !== null && props.contributing < props.expected);

const caveat = computed(() =>
    i18n.global.t('views.monitoring.activeGroups.texts.camerasDegraded', {
        contributing: props.contributing,
        expected: props.expected,
    })
);

return (_ctx: any,_cache: any) => {
  return (isDegraded.value)
    ? (_openBlock(), _createElementBlock("span", {
        key: 0,
        class: "cursor-help",
        title: caveat.value
      }, [
        _createVNode(_unref(CameraOff), {
          class: "h-3.5 w-3.5 shrink-0 text-amber-500",
          "aria-hidden": "true"
        })
      ], 8, _hoisted_1))
    : _createCommentVNode("", true)
}
}

})